import React, { FunctionComponent } from 'react';
import SterlingDrawer from '../../../../sterling/SterlingDrawer';
import { Button, ButtonGroup } from '@blueprintjs/core';

export interface LocalNecessityProps {
    localNecessity: string | null
    setLocalNecessity: (ln: string | null) => void
}

const LocalNecessity: FunctionComponent<LocalNecessityProps> = props => {

    const {
        localNecessity
    } = props;

    const showTrue = localNecessity === 'true';
    const showFalse = localNecessity === 'false';

    return (
        <SterlingDrawer.Section
            title={'Local Necessity'}>
            <ButtonGroup>
                <Button
                    active={showTrue}
                    onClick={() => {
                        showTrue
                            ? props.setLocalNecessity(null)
                            : props.setLocalNecessity('true');
                    }}
                    text={'Highlight LN+'}/>
                <Button
                    active={showFalse}
                    onClick={() => {
                        showFalse
                            ? props.setLocalNecessity(null)
                            : props.setLocalNecessity('false');
                    }}
                    text={'Highlight LN-'}/>
            </ButtonGroup>
        </SterlingDrawer.Section>
    )

}

export default LocalNecessity;